import xhr from './xhr'

export default function getWithXHR(url) {
  return xhr({ url, method: 'get' }).then(resp => resp.data)
}
